// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Gqx23","full":"Select_full__a10+0","middle":"Select_middle__CHvL3"};